import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchEnterpriseReleaseInfo } from "../api/enterpriseClient";

type UseGetReleaseInfoOptions = {
  enabled?: boolean;
};

export const releaseInfoQueryOptions = () =>
  queryOptions({
    queryKey: ["enterprise-release-info"],
    queryFn: fetchEnterpriseReleaseInfo,
    staleTime: 60_000,
  });

export function useGetReleaseInfo({
  enabled = true,
}: UseGetReleaseInfoOptions = {}) {
  return useQuery({
    ...releaseInfoQueryOptions(),
    enabled,
  });
}
